import React, { useCallback, useEffect, useMemo } from 'react';

import { useOnceReveal } from '@common/hooks';
import { PdpProductSizeType } from '@domains/pdp-common';

import { SimilarSizeView } from '../components/SimilarSizeView';
import { useSizeRecommendationUBL } from '../log/useSizeRecommendationUBL';
import { useSimilarSizeService } from '../services/useSimilarSizeService';

export const SimilarSizeContainer: React.FC = () => {
  const {
    userAccount,
    isPurchaseType,
    recommendSizeText,
    displayedOptions,
    isReviewButtonVisible,
    onReviewClick,
    onUserFigureClick,
  } = useSimilarSizeService();

  const { similarSizeImpressionUBL, similarSizeButtonImpressionUBL, similarSizeButtonClickUBL } =
    useSizeRecommendationUBL();
  const { targetRef, isRevealed } = useOnceReveal();

  // UBL 데이터 생성
  const ublParams = useMemo(
    () => ({
      recommendation_type: isPurchaseType ? PdpProductSizeType.PURCHASE : PdpProductSizeType.OPTION,
      option_value_list: displayedOptions.map((option: { ranking: number; name: string }) => ({
        ranking: option.ranking,
        name: option.name,
      })),
    }),
    [isPurchaseType, displayedOptions],
  );

  // 사이즈 추천 노출 로그
  useEffect(() => {
    if (isRevealed && userAccount && recommendSizeText) {
      similarSizeImpressionUBL(ublParams);

      // 내 체형 리뷰 보기 버튼 노출 로그
      if (isReviewButtonVisible) {
        similarSizeButtonImpressionUBL(ublParams);
      }
    }
  }, [
    isRevealed,
    userAccount,
    recommendSizeText,
    isReviewButtonVisible,
    similarSizeImpressionUBL,
    similarSizeButtonImpressionUBL,
    ublParams,
  ]);

  // 내 체형 리뷰 보기 버튼 클릭 핸들러 (로그 포함)
  const handleReviewClick = useCallback(() => {
    similarSizeButtonClickUBL(ublParams);
    onReviewClick();
  }, [similarSizeButtonClickUBL, ublParams, onReviewClick]);

  if (!userAccount || !recommendSizeText) {
    return null;
  }

  return (
    <div ref={targetRef}>
      <SimilarSizeView
        userAccount={userAccount}
        isPurchaseType={isPurchaseType}
        recommendSizeText={recommendSizeText}
        displayedOptions={displayedOptions}
        isReviewButtonVisible={isReviewButtonVisible}
        onReviewClick={handleReviewClick}
        onUserFigureClick={onUserFigureClick}
      />
    </div>
  );
};
